import { Sparkles, Image, ListChecks, Flame, Target, Rocket, Zap, Calendar } from "lucide-react";
import HubPage from "@/components/shell/HubPage";
import AssessmentScheduleCard from "@/components/home/AssessmentScheduleCard";

export default function JourneyHub() {
  return (
    <HubPage
      title="Journey"
      intro="Where you're heading, and the small steps that get you there."
      path="/hub/journey"
      groups={[
        {
          title: "Your plan",
          links: [
            { to: "/journey", label: "Growth Journey", hint: "Milestones and progress over time", icon: Sparkles },
            { to: "/next-steps", label: "Next Step", hint: "The 5 things to do this month", icon: ListChecks },
            { to: "/vision-board", label: "Vision Board", hint: "Your goals and Daily Momentum", icon: Image },
            { to: "/command-center", label: "Command Center", hint: "Your future, planned", icon: Rocket },
          ],
        },
        {
          title: "Keep growing",
          links: [
            { to: "/growth-plan", label: "30-Day Plan", hint: "A month of small wins", icon: Flame },
            { to: "/goals", label: "Goals", hint: "What you're working toward", icon: Target },
            { to: "/challenges", label: "Daily Challenge", hint: "One quick thing today", icon: Zap },
          ],
        },
      ]}
    >
      <section aria-label="Reminders">
        <div className="mb-3 flex items-center gap-2 px-1 text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">
          <Calendar className="h-3.5 w-3.5" aria-hidden="true" /> Reminders
        </div>
        <AssessmentScheduleCard />
      </section>
    </HubPage>
  );
}
